import { utils, LitElement, html } from '@hh/global.js'

const { serializeForm, addToCart, reRenderShopifySections } = utils

class HHProductCardForm extends LitElement {
  constructor() {
    super()

    this.form = this.querySelector('form')
    this.submitButton = this.querySelector('button[type="submit"]')
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))

    this.handleMouseOver = this.handleMouseOver.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleCardFocus = this.handleCardFocus.bind(this)
    this.handleCardBlur = this.handleCardBlur.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
    this.handleSwatchFocus = this.handleSwatchFocus.bind(this)
    this.handleSwatchBlur = this.handleSwatchBlur.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
    this.swatches = this.closest('.card-wrapper').querySelectorAll(
      '.card-information__colors .card__swatch'
    )
    this.swatches.forEach((swatch) => {
      swatch.addEventListener('mouseover', this.handleMouseOver)
      swatch.addEventListener('mouseleave', this.handleMouseLeave)
      swatch.addEventListener('focus', this.handleSwatchFocus)
      swatch.addEventListener('blur', this.handleSwatchBlur)
    })

    this.cardWrapper = this.closest('.card-wrapper')
    this.cardInformationColors = this.cardWrapper.querySelector(
      '.card-information__colors'
    )
    this.cardWrapper.addEventListener('focusin', this.handleCardFocus)
    this.cardWrapper.addEventListener('focusout', this.handleCardBlur)

    if (!this.submitButton) return
    this.submitButton.addEventListener('focus', this.handleFocus)
    this.submitButton.addEventListener('blur', this.handleBlur)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.swatches.forEach((swatch) => {
      swatch.removeEventListener('mouseover', this.handleMouseOver)
      swatch.removeEventListener('mouseleave', this.handleMouseLeave)
      swatch.removeEventListener('focus', this.handleSwatchFocus)
      swatch.removeEventListener('blur', this.handleSwatchBlur)
    })
    this.cardWrapper.removeEventListener('focusin', this.handleCardFocus)
    this.cardWrapper.removeEventListener('focusout', this.handleCardBlur)

    if (!this.submitButton) return
    this.submitButton.removeEventListener('focus', this.handleFocus)
    this.submitButton.removeEventListener('blur', this.handleBlur)
  }

  handleFocus(evt) {
    this.form.classList.add('focused')
  }

  handleBlur(evt) {
    this.form.classList.remove('focused')
  }

  handleCardFocus(evt) {
    this.cardWrapper.classList.add('--fake-focus')
  }

  handleCardBlur(evt) {
    const newTarget = evt.relatedTarget

    if (!this.cardWrapper.contains(newTarget)) {
      this.cardWrapper.classList.remove('--fake-focus')
    }
  }

  handleMouseOver(evt) {
    const parentElement = evt.currentTarget.closest('.card__image')
    const imageURL = evt.currentTarget.getAttribute('data-variant-image')
    const swatchImage = parentElement.querySelector('.media--card__swatch')
    swatchImage.style.backgroundImage = `url(${imageURL})`
    swatchImage.style.display = 'block'
  }

  handleMouseLeave(evt) {
    const parentElement = evt.currentTarget.closest('.card__image')
    const swatchImage = parentElement.querySelector('.media--card__swatch')
    swatchImage.style.backgroundImage = 'none'
    swatchImage.style.display = 'none'
  }

  handleKeydown(evt) {
    if (['ArrowDown', 'ArrowUp'].includes(evt.key)) {
      evt.preventDefault()
      const currentIndex = Array.from(this.swatches).indexOf(evt.target)
      const nextIndex = ['ArrowRight', 'ArrowDown'].includes(evt.key)
        ? currentIndex + 1
        : currentIndex - 1
      if (nextIndex >= 0 && nextIndex < this.swatches.length) {
        this.swatches[nextIndex].focus()
      }
    } else if (['ArrowRight', 'ArrowLeft'].includes(evt.key)) {
      evt.preventDefault()
    }
  }

  handleSwatchFocus(evt) {
    evt.target.removeEventListener('keydown', this.handleKeydown)
    evt.target.addEventListener('keydown', this.handleKeydown)
    this.handleMouseOver(evt)
  }

  handleSwatchBlur(evt) {
    evt.target.removeEventListener('keydown', this.handleKeydown)
    this.handleMouseLeave(evt)
  }

  toggleButtonState(isLoading) {
    if (!this.submitButton) return
    if (isLoading) {
      this.submitButton.setAttribute('disabled', true)
      this.submitButton.classList.add('loading')
    } else {
      this.submitButton.removeAttribute('disabled')
      this.submitButton.classList.remove('loading')
    }
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    this.toggleButtonState(true)

    const formPayload = JSON.parse(serializeForm(this.form))
    const sections = document.body.classList.contains('template-cart')
      ? 'mini-cart,header,inline-cart'
      : undefined
    const addedProduct = await addToCart(formPayload, sections)

    reRenderShopifySections(addedProduct)

    this.dispatchEvent(
      new CustomEvent('productAdded', {
        bubbles: true,
        composed: true,
      })
    )

    this.toggleButtonState(false)
    affirm?.ui.refresh()
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-card-form', HHProductCardForm)
